import React, { Fragment, useEffect, useState } from "react";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Container } from "reactstrap";
import { Tabs, Card } from "antd";
import Profile from "./profile";
import ProjectMembers from "./members";
import ApprovalFlow from "./approvalFlow";
import { useLocation, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import { LogEvents, LoggerContext } from "../../../../context/logging";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const ProjectSettings = () => {
  const location = useLocation();
  const logger = React.useContext(LoggerContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const [activeKey, setActiveKey] = useState("1");
  useEffect(() => {
    logger.log(LogEvents.projectSettings, {});
  }, [activeKey]);
  const { TabPane } = Tabs;
  return (
    <React.Fragment>
      <Breadcrumbs
        parent="Project"
        title="Project Settings"
        mainTitle="Project Settings"
      />
      <Container fluid={true}>
        <Card>
          <Tabs
            defaultActiveKey={searchParams?.get("tab") ?? activeKey}
            type="card"
          >
            <TabPane tab="Profile" key="1">
              <Profile />
            </TabPane>
            <TabPane tab="Members" key="2">
              <ProjectMembers />
            </TabPane>
            <TabPane tab="Project Approval Flow" key="3">
              <ApprovalFlow />
            </TabPane>
          </Tabs>
        </Card>
      </Container>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ProjectSettings);
